import styled from "styled-components";
import { PrimaryButton } from "components/Button/style";

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TextoHeader = styled.span`
  color: ${({ theme }) => theme.colors.neutral.neutral90};
  font-weight: bold;
  font-size: 1.2rem;
`;

export const ButtonSalvar = styled(PrimaryButton)`
  width: 9rem;
  height: 2rem;
  font-size: 0.8rem;
`;
